import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Icon } from '../../components';

import css from './CreatorsPage.module.css';

const platformItem = (title, text, iconName) => (
  <div className={css.platformItem}>
    <h2 className={css.platformItemTitle}>
      <Icon name={iconName} size={24} />
      {title}
    </h2>
    <p className={css.platformItemText}>{text}</p>
  </div>
);

const SectionPlatform = () => {
  return (
    <div className={css.sectionPlatform}>
      <div className={css.platformContent}>
        <h2 className={css.platformTitle}>
          <FormattedMessage id="CreatorsPage.platformTitle" />
        </h2>
        <p className={css.platformText}>
          <FormattedMessage id="CreatorsPage.platformText" />
        </p>
      </div>
      <div className={css.platformItems}>
        {platformItem(
          'Creator Dashboard',
          'Transform your behind-the-scenes content into a membership-driven new media experience. The Creator Dashboard is an all-in-one solution for creators to build and grow their memberships.',
          'dashboard'
        )}
        {platformItem(
          'Insights',
          'Track your growth, membership revenues, Live episode viewership, and cumulative members to keep building and engaging with your community.',
          'insights'
        )}
        {platformItem(
          'Payment',
          "We've made payments easy. With Stripe integration, all you need to do is register your bank account to your profile and start selling.",
          'money'
        )}
        {platformItem(
          'Teams',
          'Grow and manage your community with your team by granting admin access to collaborators.',
          'users'
        )}
        {platformItem(
          'Artist & Cast Credits',
          'Ensure artists and casts get the visibility and recognition they deserve on Production Pages. Once credited, they can promote the production page from their Live Room.',
          'credits'
        )}
        {platformItem(
          'Showcase',
          'Elevate your organization and profile by showcasing credits, key information, and more to attract new opportunities.',
          'star'
        )}
      </div>
    </div>
  );
};

export default SectionPlatform;
